<template>
    <div class="Gesture" :class="{ disable : disable }">  
      <video class="Gesture__video" id="video" playsinline style="
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
            visibility: auto;
            width: auto;
            height: auto;
            position: absolute;">
        </video>
      <div class="Gesture__hand ">{{ fdl }}</div>
      <div class="Gesture__hand right">{{ fdl }}</div>  
    </div>
</template>

<script>

import gsap from "gsap"
const handpose = require('@tensorflow-models/handpose')
require('@tensorflow/tfjs-backend-webgl');

export default {

  name: 'Gesture',
  render: h => h(), 
  data: ()=>({

    fdl: 0,
    fdr: 0,
    plx: 0,
    prx: 0,
    nwl: 0,
    nwr: 0,
    lft_locked : false,
    rgt_locked: false,
    disable: false

  }),
  beforeDestroy() {
    // if(this.rafID)
    //   cancelAnimationFrame(this.rafID)
    // this.removeGesture()
  },
  mounted() {
    console.log('Gesture');
    this.init()
  },

  methods: {

    setupCamera: async function() { 
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error(
            'Browser API navigator.mediaDevices.getUserMedia not available')
      }
      const video = document.getElementById('video')
      const stream = await navigator.mediaDevices.getUserMedia({
        'audio': false,
        'video': {
          facingMode: 'user',
          width: 320,
          height: 240
        },
      })
      video.srcObject = stream
      return new Promise((resolve) => {
        video.onloadedmetadata = () => { resolve(video) }
      })
    },

    loadVideo: async function() {
      const video = await this.setupCamera()
      video.play()
      return video
    },

    init: async function() {
      
      this.$model = await handpose.load();
      let video
      try {
        video = await this.loadVideo()
        this.onLoop()

      } catch (e) {
        
        console.log('catch '+ e);

        throw e;
      }

    },

    onLoop: async function() {

      this.$predictions = await this.$model.estimateHands(document.querySelector("video"))
      let res = ''

      if (this.$predictions.length > 0) {

        // console.log(this.$predictions);

        // LEFT HAND

        const finger = 0
        const keypoints = this.$predictions[0].landmarks;
        const hand = keypoints[finger][0]

        res = Math.round(hand)

        if(hand < 200)
           this.motionLeft()    
      }
        

      this.fdl = res
      this.rafID = requestAnimationFrame(this.onLoop)   
    },
    // removeScreens() {
    //   console.log('x');
    //   gsap.set('.Gesture-debugger', { 'display' : 'none' })
    // },

    // removeGesture() {
    //   // TODO . 
    // },
    motionLeft() {
      if(this.lft_locked == true)
        return
      this.lft_locked = true
      this.$store.commit('app/MOTION_LEFT')
      gsap.delayedCall(.5, ()=>{ this.lft_locked = false })
    },
  }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Gesture
  position absolute 
  top 0 
  left 0
  width 100vw

  &__hand 
    position absolute
    border 1px solid red
    padding 4px 16px
    width 300px
    background red
    text-align center
    height 27px

    &.right 
      right 0

  &__video 
    top 50px
    right 13px

   
</style>















